// Customizable Area Start
import React, { Component } from "react";

interface VideoLevelIconProps {
  isOff: boolean;
}

class VideoLevelIcon extends Component<VideoLevelIconProps> {
  render() {
    const { isOff } = this.props;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.35398 13.6134H4.14065C2.03398 13.6134 1.33398 12.2134 1.33398 10.8067V5.19339C1.33398 3.08672 2.03398 2.38672 4.14065 2.38672H8.35398C10.4607 2.38672 11.1607 3.08672 11.1607 5.19339V10.8067C11.1607 12.9134 10.454 13.6134 8.35398 13.6134Z"
          stroke="white"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.0135 11.4001L11.1602 10.1001V5.89342L13.0135 4.59342C13.9202 3.96009 14.6668 4.34675 14.6668 5.46009V10.5401C14.6668 11.6534 13.9202 12.0401 13.0135 11.4001Z"
          stroke="white"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.66797 7.33398C8.22025 7.33398 8.66797 6.88627 8.66797 6.33398C8.66797 5.7817 8.22025 5.33398 7.66797 5.33398C7.11568 5.33398 6.66797 5.7817 6.66797 6.33398C6.66797 6.88627 7.11568 7.33398 7.66797 7.33398Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />

        {isOff && (
          <line
            x1="3"
            y1="2"
            x2="13"
            y2="13"
            stroke="#fff"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        )}
      </svg>
    );
  }
}

export default VideoLevelIcon;
// Customizable Area End
